<div class="language-switcher flex flex-row justify-center items-center gap-2 lg:gap-3">
  <!-- Custom Language Buttons -->
  <button *ngFor="let language of availableLanguages" (click)="switchLanguage(language.code)"
    type="button"
    class="flex items-center gap-1.5 transition-all duration-200 ease-in-out px-3 py-1.5 rounded-lg border text-xs sm:text-sm cursor-pointer"
    [class.font-bold]="isCurrentLanguage(language.code)"
    [class.border-orange-500]="isCurrentLanguage(language.code)"
    [class.bg-orange-500]="isCurrentLanguage(language.code)"
    [class.text-white]="isCurrentLanguage(language.code)"
    [class.shadow-sm]="isCurrentLanguage(language.code)"
    [class.border-gray-200]="!isCurrentLanguage(language.code)"
    [class.bg-white]="!isCurrentLanguage(language.code)"
    [class.text-gray-700]="!isCurrentLanguage(language.code)"
    [class.hover:border-orange-300]="!isCurrentLanguage(language.code)"
    [class.hover:bg-orange-50]="!isCurrentLanguage(language.code)"
    [attr.aria-label]="'Zmień język na ' + language.name"
    [title]="language.name">
    <span class="text-base leading-none">{{ language.flag }}</span>
    <span class="font-semibold">{{ language.code.toUpperCase() }}</span>
  </button>
</div>